import VoiceoverIcon from "@/assets/icons/voiceover-icon.svg";
import type React from "react";
import CaptionIcon from "../../assets/caption-icon.svg";
import ImageIcon from "../../assets/image-icon.svg";
import MusicIcon from "../../assets/music-icon.svg";
import SubtitleIcon from "../../assets/subtitle-icon.svg";
import VideoIcon from "../../assets/video-icon.svg";
import { TimelineMediaKind, VisualTrackKind } from "../../types";

export const TRACK_ICON_WIDTH = 48;
export const TIMELINE_PADDING = 4; // px-1
export const TIMELINE_CONTENT_OFFSET = TRACK_ICON_WIDTH + TIMELINE_PADDING;

export type TrackTheme = {
  height: number;
  borderColor: string;
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>> | null;
};

const DEFAULT_THEME: TrackTheme = {
  height: 30,
  borderColor: "#D2E573",
  Icon: null,
};

const SHOT_THEME: TrackTheme = {
  height: 50,
  borderColor: "#D7B5F0",
  Icon: CaptionIcon,
};

const SUBTITLE_THEME: TrackTheme = {
  height: 30,
  borderColor: "#D7B5F0",
  Icon: SubtitleIcon,
};

const TRACK_THEME: Record<TimelineMediaKind, TrackTheme> = {
  video: {
    height: 50,
    borderColor: "#D2E573",
    Icon: VideoIcon,
  },
  image: {
    height: 50,
    borderColor: "#D2E573",
    Icon: ImageIcon,
  },
  audio: {
    height: 30,
    borderColor: "#6766CC",
    Icon: VoiceoverIcon,
  },
  music: {
    height: 30,
    borderColor: "#6766CC",
    Icon: MusicIcon,
  },
  shot: SHOT_THEME,
  lyrics: SUBTITLE_THEME,
  empty: SHOT_THEME,
};

export const getTrackTheme = (kind: TimelineMediaKind): TrackTheme =>
  TRACK_THEME[kind] ?? DEFAULT_THEME;

const VISUAL_TRACK_KINDS: VisualTrackKind[] = ["video", "image", "shot"];

export const isVisualTrackKind = (
  kind: TimelineMediaKind
): kind is VisualTrackKind =>
  VISUAL_TRACK_KINDS.includes(kind as VisualTrackKind);
